/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-key */
import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react';
import {
  Cell,
  Column,
  useFilters,
  useGlobalFilter,
  useSortBy,
  useTable
} from 'react-table';

import { DefaultFilterForColumn } from './utils/Filters';

type TableProps = {
  title?: string;
  itemsCount?: number;
  columns: Column<object>[];
  data: object[];
  total: string;
  details?: {
    columns: string[];
    values: object[];
  };
  modalTitle?: string;
  sort?: string;
};

export const InteractiveTableModal = ({
  columns,
  data,
  sort,
  itemsCount,
  total
}: TableProps): JSX.Element => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable<object>(
      {
        columns,
        data,
        initialState: {
          pageIndex: 0,
          sortBy: [
            {
              id: sort ? sort : '',
              desc: false
            }
          ]
        },
        defaultColumns: { Filer: DefaultFilterForColumn }
      },
      useFilters,
      useGlobalFilter,
      useSortBy
    );

  return (
    <>
      <TableContainer maxH="20rem" overflowY="auto">
        <Table
          color="#1C375C"
          size="sm"
          colorScheme="whiteAlpha"
          position="relative"
        >
          <Thead
            h="3.25rem"
            z-index={9}
            position="sticky"
            top={0}
            zIndex={999}
            transform="translateX(-4px)"
          >
            {headerGroups.map((headerGroup) => (
              <Tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    whiteSpace="normal"
                    background="#fff"
                    textTransform="none"
                    {...column.getHeaderProps(
                      column.getSortByToggleProps({ title: 'Ordenar' })
                    )}
                    fontSize=".9rem"
                    color="#1C375C"
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <TriangleDownIcon ml="0.5rem" />
                        ) : (
                          <TriangleUpIcon ml="0.5rem" />
                        )
                      ) : (
                        <></>
                      )}
                    </span>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>

          <Tbody {...getTableBodyProps()}>
            {rows.slice(0, itemsCount).map((row: any, index: number) => {
              prepareRow(row);
              return (
                <Tr
                  {...row.getRowProps()}
                  transition="all .4s ease-in-out"
                  h="3rem"
                  _odd={{
                    background: '#F3F3F3'
                  }}
                >
                  <Td fontSize="1rem" color="#1C375C" textTransform="none">
                    {index === 0 ? total : ''}
                  </Td>
                  {row.cells.slice(1).map((cell: Cell<object, any>) => {
                    return (
                      <Td
                        fontSize="1rem"
                        textTransform="none"
                        whiteSpace="pre-line"
                        {...cell.getCellProps()}
                      >
                        {cell.render('Cell')}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
